import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Title from "../components/common/Title";
import AppFrame from "./Appframe/AppFrame";
import _ from "lodash";
import * as actionCreators from "../actions/apps";

import Alert from "@material-ui/lab/Alert";
import Switch from "@material-ui/core/Switch";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";

import csatExample from "../resources/images/csat_example.png";
import npsExample from "../resources/images/nps_example.png";
import confettiExample from "../resources/images/confetti_example.png";
import ptsExample from "../resources/images/points_example.png";

import { Input, Select } from "@material-ui/core";
import { DropDownMenu, IconButton, MenuItem } from "material-ui";
import { ListItem } from "material-ui/List";

import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import AppSettingsService from "../services/appSettings";
import PhysioService from "../services/physiotec";
import { Mixpanel } from "../mixpanel";
import HelpIcon from "@material-ui/icons/Help";
import RaisedButton from "material-ui/RaisedButton";

import "../styles/page/appSettings.css";

class AppSettings extends Component {
  constructor(props) {
    super(props);

    const appId = props.match.params.appId;
    const appInfo = props.apps.appInfos[props.match.params.appId];

    this.state = {
      appId,
      appInfo,
      showSaved: false,
      showUserInstructions: false,
      showNPSExample: false,
      showCSATExample: false,
      showConfettiExample: false,
      showAwardsExample: false,
      sentOk: false,
      npsEnabled: !!appInfo.npsEnabled,
      csatEnabled: !!appInfo.csatEnabled,
      autoTrackTimeInChart: !!appInfo.autoTrackTimeInChart,
      webReviewEnabled: !!appInfo.webReviewEnabled,
      yelpUrl: appInfo.yelpUrl ? appInfo.yelpUrl : "",
      googleUrl: appInfo.googleUrl ? appInfo.googleUrl : "",
      physioEnabled: !!appInfo.physioEnabled,
      customEmailEnabled: !!appInfo.customEmailEnabled,
      confettiEnabled: !!appInfo.confettiEnabled,
      awardsEnabled: !!appInfo.awardsEnabled,
      csatWeekInterval: appInfo.csatWeekInterval ? appInfo.csatWeekInterval : 6,
    };
    this.saveChanges = this.saveChanges.bind(this);
    this.goToEditWelcome = this.goToEditWelcome.bind(this);
  }

  componentDidMount() {
    PhysioService()
      .getIntegrationEnabled(this.state.appId)
      .then((response) => {
        if (response) {
          this.setState({
            physioEnabled: response.isIntegrationEnabled,
            physioEntityNumber: response.entityNumber,
          });
        }
      })
      .catch((err) => {});
    AppSettingsService()
      .getOnboardinSettings(this.state.appId)
      .then((response) => {
        if (response) {
          this.setState({
            customEmailEnabled: response.customEmailEnabled,
            customWelcomeProgramEnabled: response.customWelcomeProgramEnabled,
          });
        }
      });
  }

  componentWillUnmount() {}

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      let appInfo = nextProps.apps.appInfos[this.state.appId];
      if (appInfo) {
        this.setState({
          appInfo,
          npsEnabled: appInfo.npsEnabled != null ? appInfo.npsEnabled : false,
          csatEnabled: appInfo.csatEnabled ? appInfo.csatEnabled : false,
          autoTrackTimeInChart: appInfo.autoTrackTimeInChart
            ? !!appInfo.autoTrackTimeInChart
            : false,
          webReviewEnabled: appInfo.webReviewEnabled
            ? appInfo.webReviewEnabled
            : false,
          yelpUrl: appInfo.yelpReviewUrl ? appInfo.yelpReviewUrl : "",
          googleUrl: appInfo.googleReviewUrl ? appInfo.googleReviewUrl : "",
          confettiEnabled:
            appInfo.confettiEnabled != null ? appInfo.confettiEnabled : true,
          awardsEnabled:
            appInfo.awardsEnabled != null ? appInfo.awardsEnabled : true,
        });
      }
    }
  }

  saveChanges() {
    let aInfo = this.state.appInfo;

    aInfo.autoTrackTimeInChart = this.state.autoTrackTimeInChart;
    aInfo.csatEnabled = this.state.csatEnabled;
    aInfo.npsEnabled = this.state.npsEnabled;
    aInfo.webReviewEnabled = this.state.webReviewEnabled;
    aInfo.csatWeekInterval = this.state.csatWeekInterval;
    aInfo.yelpUrl = this.state.yelpReviewUrl;
    aInfo.googleReviewUrl = this.state.googleReviewUrl;
    aInfo.confettiEnabled = this.state.confettiEnabled;
    aInfo.awardsEnabled = this.state.awardsEnabled;

    this.props.updateAppInfo(this.props.userId, this.state.appId, aInfo);
    Mixpanel.track("Update channel detail", {
      "Channel Name": this.state.appInfo.appName,
      "Channel ID": this.state.appId,
      "App Type": this.state.appInfo.appType,
    });
    this.setState({ showSaved: true });
    setTimeout(() => {
      this.setState({ showSaved: false });
    }, 2000);
  }

  goToEditWelcome() {
    let link = `/edit-custom-welcome`;
    this.props.history.push(link);
  }

  render() {
    return (
      <AppFrame>
        <Title
          text2={"Channel Customization"}
          goBack={() => this.props.history.goBack()}
          whiteLabelSettings={this.props.whiteLabelSettings}
        />
        <div className="page">
          <div className="save-header">
            {this.state.showSaved && (
              <Alert
                severity="success"
                color="success"
                style={{ marginRight: 50 }}
              >
                Customizations Saved Successfully
              </Alert>
            )}
            <div>
              <RaisedButton
                primary={!this.props.whiteLabelSettings.isWhiteLabel}
                onClick={this.saveChanges}
                label="Save"
              ></RaisedButton>
            </div>
          </div>
          <div className="section">
            <h1 className="section-header">Onboarding</h1>
            <div className="section-content">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={this.state.customEmailEnabled}
                      onChange={() => {
                        let enabled = !this.state.customEmailEnabled;
                        AppSettingsService()
                          .enableCustomEmail(this.state.appInfo.appId, enabled)
                          .then((response) => {
                            this.setState({ customEmailEnabled: enabled });
                          });
                      }}
                    />
                  }
                  labelPlacement="start"
                  label="Enable Custom Welcome Email"
                />
                {this.state.customEmailEnabled && (
                  <Button
                    variant="outlined"
                    style={{ margin: 20 }}
                    onClick={() => {
                      this.goToEditWelcome();
                    }}
                  >
                    Edit Welcome Email
                  </Button>
                )}
              </FormGroup>
              <Alert severity="success" color="info">
                Enabling the custom welcome email will allow you to set the
                subject and email body for the welcome email sent to new
                clients.
              </Alert>
              <FormGroup row style={{ marginTop: 15 }}>
                <FormControlLabel
                  control={
                    this.state.customWelcomeProgramEnabled ? (
                      <Switch
                        size="medium"
                        checked={this.state.customWelcomeProgramEnabled}
                        onChange={(e) => e.preventDefault()}
                      />
                    ) : (
                      <Button
                        variant="outlined"
                        style={{ margin: 20 }}
                        onClick={() => {
                          AppSettingsService()
                            .requestWelcomeProgramAccess(this.state.appId)
                            .then(() => {
                              this.setState({ showRequestSent: true });
                              setTimeout(() => {
                                this.setState({ showRequestSent: false });
                              }, 3000);
                            });
                        }}
                      >
                        Request Access To Custom Welcome Program
                      </Button>
                    )
                  }
                  labelPlacement="start"
                  label="Enable Custom Welcome Program"
                />
              </FormGroup>

              {this.state.showRequestSent && (
                <Alert
                  severity="success"
                  style={{ marginTop: 10, marginBottom: 10 }}
                >
                  Request sent to the AC Health Team. A member of the team
                  should be in touch shortly with more information!
                </Alert>
              )}
              <Alert severity="success" color="info">
                Enabling the custom welcome program will allow you to assign
                default content to every new client.
              </Alert>
            </div>
          </div>
          <div className="section">
            <h1 className="section-header">
              Remote Therapeutic Monitoring (RTM)
            </h1>
            <div className="section-content">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={this.state.autoTrackTimeInChart}
                      onChange={() => {
                        const newState = !this.state.autoTrackTimeInChart;
                        this.setState({
                          autoTrackTimeInChart: newState,
                        });
                      }}
                    />
                  }
                  labelPlacement="start"
                  label="Enable Automatic Tracking Of Time In Chart"
                />
              </FormGroup>
              <Alert severity="success" color="info">
                Enabling time tracking for RTM patients allows the system to
                report time spent on remote therapeutic monitoring without
                having to self report the time you spend on each patient.
              </Alert>
            </div>
          </div>

          <div className="section">
            <h1 className="section-header">App Features</h1>
            <div className="section-content">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={this.state.confettiEnabled}
                      onChange={() => {
                        const newState = !this.state.confettiEnabled;
                        this.setState({
                          confettiEnabled: newState,
                        });
                      }}
                    />
                  }
                  labelPlacement="start"
                  label="Confetti Cannon Celebration Enabled"
                />
              </FormGroup>
              <Alert severity="success" color="info">
                Show your clients a confetti celebration every time they
                complete an instruction.
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignContent: "center",
                    marginTop: 10,
                  }}
                >
                  <Button
                    style={{ marginLeft: "auto" }}
                    onClick={() => {
                      this.setState({ showConfettiExample: true });
                    }}
                  >
                    See Example
                  </Button>
                </div>
              </Alert>
              <Dialog
                open={this.state.showConfettiExample}
                onClose={() => {
                  this.setState({ showConfettiExample: false });
                }}
              >
                <DialogContent>
                  <img
                    src={confettiExample}
                    style={{ height: "550px" }}
                    alt="confetti example"
                  />
                </DialogContent>
              </Dialog>
            </div>
            <div className="section-content">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={this.state.awardsEnabled}
                      onChange={() => {
                        const newState = !this.state.awardsEnabled;
                        this.setState({
                          awardsEnabled: newState,
                        });
                      }}
                    />
                  }
                  labelPlacement="start"
                  label="Points/Awards Enabled"
                />
              </FormGroup>
              <Alert severity="success" color="info">
                Enable the points and awards section of the app in order to
                display point earnings and custom awards for your clients.
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignContent: "center",
                    marginTop: 10,
                  }}
                >
                  <Button
                    style={{ marginLeft: "auto" }}
                    onClick={() => {
                      this.setState({ showAwardsExample: true });
                    }}
                  >
                    See Example
                  </Button>
                </div>
              </Alert>
              <Dialog
                open={this.state.showAwardsExample}
                onClose={() => {
                  this.setState({ showAwardsExample: false });
                }}
              >
                <DialogContent>
                  <img
                    src={ptsExample}
                    style={{ height: "550px" }}
                    alt="Points Modal Example"
                  />
                </DialogContent>
              </Dialog>
            </div>
          </div>
          <div className="section">
            <h1 className="section-header">Third-Party Integration</h1>
            <div className="section-content">
              <div style={{ marginBottom: 50 }}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Switch
                        size="medium"
                        checked={this.state.physioEnabled}
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      />
                    }
                    labelPlacement="start"
                    label="Physiotec/Wibbi Integrated Library Content Enabled"
                  />
                </FormGroup>

                {this.state.physioEnabled && (
                  <Alert severity="success" color="info">
                    Physiotec/Wibbi Integrated Library is enabled allowing you to
                    select pre-recorded instructions and sync them with your AC
                    Health account. View your library to get started.
                  </Alert>
                )}
                {!this.state.physioEnabled && (
                  <Alert severity="info" color="warning">
                    Physiotec/Wibbi Integrated Library is not enabled.
                    <Button
                      variant="outlined"
                      style={{ margin: 20 }}
                      onClick={() => {
                        PhysioService()
                          .requestPhsyioAccess(this.state.appId)
                          .then(() => {
                            alert(
                              "The AC Health team has been notified of your request"
                            );
                          });
                      }}
                    >
                      Request Access To Integrated Library
                    </Button>
                  </Alert>
                )}
              </div>
            </div>
          </div>

          <div className="section">
            <h1 className="section-header">Marketing Options</h1>
            <div className="section-content">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={this.state.npsEnabled}
                      onChange={() => {
                        const newState = !this.state.npsEnabled;
                        this.setState({
                          npsEnabled: newState,
                        });
                      }}
                    />
                  }
                  labelPlacement="start"
                  label="Enable NPS Survey For My Clients"
                />
              </FormGroup>
              <Alert severity="success" color="info">
                NPS Surveys are sent to patients via email after being
                discharged. Each patient may submit the NPS survey one time per
                year.
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignContent: "center",
                    marginTop: 10,
                  }}
                >
                  <Button
                    style={{ marginLeft: "auto" }}
                    onClick={() => {
                      this.setState({ showNPSExample: true });
                    }}
                  >
                    See Example
                  </Button>
                </div>
              </Alert>

              <Dialog
                open={this.state.showNPSExample}
                onClose={() => {
                  this.setState({ showNPSExample: false });
                }}
              >
                <DialogContent>
                  <img
                    src={npsExample}
                    style={{ width: "550px" }}
                    alt="nps example"
                  />
                </DialogContent>
              </Dialog>
            </div>
            <div>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={this.state.csatEnabled}
                      onChange={() => {
                        const newState = !this.state.csatEnabled;
                        this.setState({
                          csatEnabled: newState,
                        });
                      }}
                    />
                  }
                  labelPlacement="start"
                  label="Enable Client Satisfaction Survey For My Clients"
                />
              </FormGroup>
              <Alert severity="success" color="info">
                Client Satisfaction surveys will be sent to your clients based
                on the schedule selected below.
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignContent: "center",
                    marginTop: 10,
                  }}
                >
                  <Button
                    style={{ marginLeft: "auto" }}
                    onClick={() => {
                      this.setState({ showCSATExample: true });
                    }}
                  >
                    See Example
                  </Button>
                </div>
              </Alert>

              <Dialog
                open={this.state.showCSATExample}
                onClose={() => {
                  this.setState({ showCSATExample: false });
                }}
              >
                <DialogContent>
                  <img
                    src={csatExample}
                    style={{ width: "550px" }}
                    alt="csat example"
                  />
                </DialogContent>
              </Dialog>
              <div
                style={{
                  margin: 10,
                }}
              >
                {this.state.csatEnabled && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: 10,
                      justifyContent: "space-evenly",
                    }}
                  >
                    <FormControl style={{ margin: 10 }}>
                      <InputLabel id="demo-simple-select-helper-label">
                        How often should we survey your patients?
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={this.state.csatWeekInterval}
                        onChange={(event) => {
                          this.setState({
                            csatWeekInterval: event.target.value,
                          });
                        }}
                      >
                        <MenuItem value={1}>Every Week</MenuItem>
                        <MenuItem value={2}>Every Two Weeks</MenuItem>
                        <MenuItem value={3}>Every Three Weeks</MenuItem>
                        <MenuItem value={4}>Every Four Weeks</MenuItem>
                        <MenuItem value={5}>Every Five Weeks</MenuItem>
                        <MenuItem value={6}>Every Six Weeks</MenuItem>
                        <MenuItem value={7}>Every Seven Weeks</MenuItem>
                        <MenuItem value={8}>Every Eight Weeks</MenuItem>
                        <MenuItem value={9}>Every Nine Weeks</MenuItem>
                        <MenuItem value={10}>Every Ten Weeks</MenuItem>
                      </Select>
                    </FormControl>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Switch
                            size="medium"
                            checked={this.state.webReviewEnabled}
                            onChange={() => {
                              const newState = !this.state.webReviewEnabled;
                              this.setState({
                                webReviewEnabled: newState,
                              });
                            }}
                          />
                        }
                        labelPlacement="start"
                        label="Enable Yelp And Google Review Prompts"
                      />{" "}
                      <IconButton
                        type="primary"
                        onClick={() => {
                          this.setState({ showReviewHelp: true });
                        }}
                      >
                        <HelpIcon></HelpIcon>
                      </IconButton>
                    </FormGroup>

                    <Dialog
                      open={this.state.showReviewHelp}
                      onClose={() => {
                        this.setState({ showReviewHelp: false });
                      }}
                    >
                      <DialogContent>
                        <div>
                          <h3>Where to find Yelp Review URL</h3>
                          <ul>
                            <li>Go to https://www.yelp.ca</li>
                            <li>
                              Search for your business using the "Find" and
                              "Near" boxes on the homepage:
                            </li>
                            <li>
                              Click the name of your business in the results
                              list:
                            </li>
                            <li>
                              Click the "Write a Review" link on the upper right
                              side of the page:
                            </li>
                            <li>
                              Copy the URL from the URL bar of your browser
                            </li>
                          </ul>
                          <h3>Where to find Google Review URL</h3>
                          <li>
                            Log in with the account you used to sign up for your
                            Business Profile.
                          </li>
                          <li>
                            Search on Google for your exact business name. You
                            can also search for “my business.”
                          </li>
                          <li>
                            Select Customers And then Reviews And then Get more
                            reviews.
                          </li>
                          <li>Copy the link provided.</li>
                        </div>
                      </DialogContent>
                    </Dialog>
                    <TextField
                      id="outlined-basic"
                      label="Yelp Review URL"
                      style={{ margin: 10 }}
                      value={this.state.yelpReviewUrl}
                      disabled={!this.state.webReviewEnabled}
                      onChange={(event) => {
                        this.setState({ yelpReviewUrl: event.target.value });
                      }}
                    />

                    <TextField
                      id="outlined-basic"
                      label="Google Review URL"
                      style={{ margin: 10 }}
                      value={this.state.googleReviewUrl}
                      disabled={!this.state.webReviewEnabled}
                      onChange={(event) => {
                        this.setState({ googleReviewUrl: event.target.value });
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, whiteLabelSettings }) {
  return {
    userId: user.userId,
    user,
    apps,
    whiteLabelSettings,
  };
}
//updateAppInfo

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSettings);



// WEBPACK FOOTER //
// ./src/layout/AppSettings.js